import React, { useMemo } from 'react';
import { Container, Graphics, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { PopupTypes } from '../../../core/constants/popupTypes';
import { getGameImages } from '../../../core/helpers/getGameImages';

import { connectionPopupStore } from '../../../store/connectionPopupStore';

import ReconnectPopup from '../../../components/web/reconnect';
import SessionExpired from '../../../components/web/sessionExpired';
import ScaleComponent from '../../../components/mobile/scaleComponent';
import InsufficientAmount from '../../../components/web/insufficientAmount';
import { isMobile } from '../../../core/helpers/isMobile';

const ConnectionPopup = observer(({ x, y }) => {
  const { popupName, isOpenPopup } = connectionPopupStore;
  const { reconnectInfoBackground } = useMemo(() => {
    return getGameImages();
  }, []);

  const popupComponents = useMemo(() => {
    return {
      [PopupTypes.RECONNECT_POPUP]: ReconnectPopup,
      [PopupTypes.SESSION_EXPIRED]: SessionExpired,
      [PopupTypes.INSUFFICIENT_AMOUNT]: InsufficientAmount,
    };
  }, []);

  const PopupComponent = useMemo(() => {
    return popupComponents[popupName];
  }, [popupName, popupComponents]);

  if (!isOpenPopup) {
    return null;
  }
  return (
    <>
      <Graphics
        draw={(g) => {
          g.clear();
          g.beginFill('black');
          g.drawRect(
            0,
            0,
            isMobile() ? window.innerWidth : 1440,
            isMobile() ? window.innerHeight : 860
          );
          g.alpha = 0.8;
          g.interactive = true;
        }}
      />
      <ScaleComponent name='ConnectionPopupWrapper' isCenterHorizontal isCenterVertical>
        <Container x={x} y={y}>
          <Sprite texture={reconnectInfoBackground} />
          {PopupComponent && <PopupComponent />}
        </Container>
      </ScaleComponent>
    </>
  );
});
export default ConnectionPopup;
